import Vue from "vue";
import VueCookie from "vue-cookie";
import router from "@/router";
import store from "@/store";
import http from "@/utils/httpRequest";
import axios from "axios";

/**
 * 获取uuid
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
      16
    );
  });
}

export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区(只有在时间重新构造时才处理)
 * @param date
 */
export function parseToDate(date) {
  if (date === undefined || date === null) {
    date = new Date();
  } else if (date instanceof Date) {
    return date;
  } else {
    date = new Date(date);
  }
  return new Date(date - date.getTimezoneOffset());
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param useRaw
 */
export function getMonth(date, useRaw) {
  return parseToDate(date).getMonth() + 1;
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date 当前时间
 * @param offsetMonth 月份便宜
 */
export function getFullMonth(date, offsetMonth) {
  var cur = parseToDate(date);
  if (offsetMonth !== undefined && offsetMonth !== 0) {
    cur = addMonth(cur, offsetMonth);
  }
  return cur.getFullYear() * 100 + cur.getMonth() + 1;
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 */
export function getYear(date) {
  return parseToDate(date).getFullYear();
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param count
 */
export function addMonth(date, count) {
  var newDate;
  if (date instanceof Date) {
    newDate = new Date(date);
  } else {
    newDate = new Date(parseToDate(date));
  }
  newDate.setMonth(newDate.getMonth() + count);
  return newDate;
}

//设置默认日期
export function getMonthPickDefaultDate() {
  //获取新的时间(2019.4.12）
  let date = parseToDate();
  let fromDate = addMonth(date, -6);
  let endDate = addMonth(date, 1);
  //字符串拼接，开始时间，结束时间
  var month = fromDate.getMonth() + 1;
  let beg = fromDate.getFullYear() + "-" + (month < 10 ? "0" : "") + month;
  month = endDate.getMonth() + 1;
  let end = endDate.getFullYear() + "-" + (month < 10 ? "0" : "") + month;
  return [beg, end]; //将值设置给插件绑定的数据
}
//格式化日期 Y-年份 M-月份 d-日份
export function formatDate(date, format) {
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let day = date.getDate();
  day = day < 10 ? "0" + day : day;
  return format.replace("YYYY", y).replace("MM", m).replace("dd", day);
}

/**
 * 将日期选择的月度范围 转换为 统计要求的 [20190101,20190101]格式
 * @param value
 */
export function parseMonthPickValue(value) {
  if (
    value === undefined ||
    value.length < 2 ||
    value[0] === undefined ||
    value[1] === undefined
  ) {
    value = getMonthPickDefaultDate();
  }
  var fromDate = value[0];
  var endDate = value[1];
  let result = {};
  if (fromDate.length <= 7) {
    fromDate = fromDate + "-" + "01";
    result.from = getFullMonth(fromDate);
  } else {
    result.from = getFullMonth(new Date(fromDate));
  }
  if (endDate.length <= 7) {
    endDate = endDate + "-" + "01";
    result.end = getFullMonth(endDate, 1);
  } else {
    result.end = getFullMonth(new Date(endDate), 1);
  }
  return result;
}

export function homeTopTime() {
  var d = new Date();
  var y = d.getFullYear();
  var m = d.getMonth() + 1;
  if (m <= 9) {
    m = "0" + m;
  }
  var ds = d.getDate();
  if (ds <= 9) {
    ds = "0" + ds;
  }
  var h = d.getHours();
  if (h <= 9) {
    h = "0" + h;
  }
  var f = d.getMinutes();
  if (f <= 9) {
    f = "0" + f;
  }
  var s = d.getSeconds();
  if (s <= 9) {
    s = "0" + s;
  }
  return y + "-" + m + "-" + ds;
}

export function exceptTimeStr(timeStr) {
  let newTimeStr = timeStr.replace(/[-\s:]/g, "");
  return newTimeStr;
}

/**
 * JS获取URL中参数值
 * @param name
 * @returns {string|null}
 */
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

export function isIEBrowser() {
  //判断是否为IE内核浏览器
  var u = window.navigator.userAgent.toLocaleLowerCase();
  var msie = /(msie) ([\d.]+)/;
  var chrome = /(chrome)\/([\d.]+)/;
  var firefox = /(firefox)\/([\d.]+)/;
  var safari = /(safari)\/([\d.]+)/;
  var opera = /(opera)\/([\d.]+)/;
  var ie11 = /(trident)\/([\d.]+)/;
  var b =
    u.match(msie) ||
    u.match(chrome) ||
    u.match(firefox) ||
    u.match(safari) ||
    u.match(opera) ||
    u.match(ie11);
  if (b[1] == "msie" || b[1] == "trident") {
    return true;
  } else {
    return false;
  }
}
